/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainEntitiesDocumentsGeoTarget;
(function (FxIdDomainEntitiesDocumentsGeoTarget) {
    FxIdDomainEntitiesDocumentsGeoTarget[FxIdDomainEntitiesDocumentsGeoTarget["RussianPI"] = 0] = "RussianPI";
    FxIdDomainEntitiesDocumentsGeoTarget[FxIdDomainEntitiesDocumentsGeoTarget["GRPD"] = 1] = "GRPD";
    FxIdDomainEntitiesDocumentsGeoTarget[FxIdDomainEntitiesDocumentsGeoTarget["CCPA"] = 2] = "CCPA";
    FxIdDomainEntitiesDocumentsGeoTarget[FxIdDomainEntitiesDocumentsGeoTarget["All"] = 999] = "All";
    FxIdDomainEntitiesDocumentsGeoTarget[FxIdDomainEntitiesDocumentsGeoTarget["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainEntitiesDocumentsGeoTarget || (FxIdDomainEntitiesDocumentsGeoTarget = {}));
export function instanceOfFxIdDomainEntitiesDocumentsGeoTarget(value) {
    for (const key in FxIdDomainEntitiesDocumentsGeoTarget) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainEntitiesDocumentsGeoTarget, key)) {
            if (FxIdDomainEntitiesDocumentsGeoTarget[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainEntitiesDocumentsGeoTargetFromJSON(json) {
    return FxIdDomainEntitiesDocumentsGeoTargetFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsGeoTargetFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainEntitiesDocumentsGeoTargetToJSON(value) {
    return value;
}
export function FxIdDomainEntitiesDocumentsGeoTargetToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainEntitiesDocumentsGeoTarget.js.map